import request from '@/utils/request'

let MultigroupApi = {
  /*秒杀活动列表*/
  getAgent(data, errorback) {
    return request._post('/shop/plus.multigroup.Agent/index', data, errorback);
  },
  activeList(data, errorback) {
    return request._post('/shop/plus.multigroup.Active/index', data, errorback);
  },
  activeLogDetails(data, errorback) {
    return request._post('/shop/plus.multigroup.Active/logDetails', data, errorback);
  },
  activeGroupLog(data, errorback) {
    return request._post('/shop/plus.multigroup.Active/logLists', data, errorback);
  },
  /*添加秒杀活动*/
  addActive(data, errorback) {
    return request._post('/shop/plus.multigroup.Active/add', data, errorback);
  },
  /*获取秒杀活动数据*/
  getActive(data, errorback) {
    return request._get('/shop/plus.multigroup.Active/edit', data, errorback);
  },
  /*保存秒杀活动*/
  saveActive(data, errorback) {
    return request._post('/shop/plus.multigroup.Active/edit', data, errorback);
  },
  /*删除秒杀活动*/
  delActive(data, errorback) {
    return request._post('/shop/plus.multigroup.Active/delete', data, errorback);
  },
  /*查看商品*/
  seeActive(data, errorback) {
    return request._post('/shop/plus.multigroup.Active/see', data, errorback);
  },

  /*添加商品*/
  addProduct(data, errorback) {
    return request._post('/shop/plus.multigroup.Product/add', data, errorback);
  },
  /*获取活动已选商品*/
  selectProduct(data, errorback) {
    return request._post('/shop/plus.multigroup.Product/selectProduct', data, errorback);
  },
  /*秒杀商品详情*/
  detail(data, errorback) {
    return request._post('/shop/plus.multigroup.Product/detail', data, errorback);
  },
  /*保存秒杀商品*/
  saveData(data, errorback) {
    return request._post('/shop/plus.multigroup.Product/saveData', data, errorback);
  },
  delProduct(data, errorback) {
    return request._post('/shop/plus.multigroup.Product/delete', data, errorback);
  },

  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/plus.multigroup.Setting/index', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.multigroup.Setting/index', data, errorback);
  },
  /*获取设置*/
    getDiySkill(data, errorback) {
    return request._post('/shop/plus.multigroup.Active/getDiyProduct', data, errorback);
},
}
export default MultigroupApi;



// WEBPACK FOOTER //
// ./src/api/multigroup.js